import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUnlocked, withUnlock } from '../lib/useUnlocked';
import Logo from './Logo';
import './Navigation.css';

const Navigation = () => {
    const location = useLocation();
    const unlocked = useUnlocked();

    const [menuOpen, setMenuOpen] = useState(false);

    // Collapse the menu whenever the route changes, so a tap on a phone does
    // not leave the drawer covering the page it just navigated to.
    useEffect(() => { setMenuOpen(false); }, [location.pathname]);

    const navItems = [
        {
            path: '/guided',
            name: 'Guided',
            icon: '🧭',
            description: 'Step-by-step discovery and quote'
        },
        {
            path: '/pricing',
            name: 'Pricing',
            icon: '📋',
            description: 'The published pricing sheet'
        },
        {
            path: '/',
            name: 'Calculator',
            icon: '🧮',
            description: 'Full pricing calculator',
            staffOnly: true
        },
        {
            path: '/settings',
            name: 'Settings',
            staffOnly: true,
            icon: '⚙️',
            description: 'Calculation Settings'
        },
        {
            path: '/faq',
            name: 'FAQ',
            staffOnly: true,
            icon: '❓',
            description: 'Frequently Asked Questions'
        },
        {
            path: '/sales',
            name: 'Sales',
            staffOnly: true,
            icon: '💼',
            description: 'Sales Qualification & Objections'
        }
    ];

    // Locked: the guided flow is the whole product. Unlocked: staff tools too.
    const visibleItems = navItems.filter(item => unlocked || !item.staffOnly);

    return (
        <nav className={`main-navigation ${unlocked ? 'is-unlocked' : 'is-locked'}`}>
            <div className="nav-container">
                <Link to={withUnlock('/guided', unlocked)} className="nav-brand" aria-label="inoRain OTT Pricing">
                    <Logo height={28} />
                    <span className="nav-brand-divider" aria-hidden="true" />
                    <span className="nav-brand-text">
                        <span className="brand-title">OTT Pricing</span>
                        <span className="brand-subtitle">Streaming business planning</span>
                    </span>
                </Link>

                {visibleItems.length > 1 && <button
                    type="button"
                    className={`nav-toggle ${menuOpen ? 'open' : ''}`}
                    onClick={() => setMenuOpen(o => !o)}
                    aria-expanded={menuOpen}
                    aria-label="Toggle navigation"
                >
                    <span /><span /><span />
                </button>}

                <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                    {visibleItems.map((item) => (
                        <Link
                            key={item.path}
                            to={withUnlock(item.path, unlocked)}
                            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                            title={item.description}
                        >
                            <span className="nav-text">{item.name}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default Navigation;
